import { QueovalBase, InputModel, HtmlBase, HtmlButton, QueovalDik, ComboBox } from '../global';
import { Dictionary } from 'lodash';


export class BObjectModel extends QueovalBase {
  public summary: Array<BObjectSummary>;
  public ModelName: string;
  public IdDonneePere: string;
  public IdDonneeFils: string;
  public IdRelation: string;
  public CodeRelation: string;
  public IdentBO: string;
  public NameBO: string;
  public IdentBODisplay: string;
  public ShowSaveButton?: boolean;
  public ShowRemoveButton?: boolean;
  public ShowCreateButton?: boolean;
  public ShowImportButton?: boolean;
  public DefaultInputs: Array<InputModel>;
  public ClientData: DynamicGroup;
  public codeProp: string;
  //public Mode2: string;
  public Refresh: string;
  public Header: BObjectHeader;
  public Body: BObjectBody;

  constructor() {
    super();
    this.Header = new BObjectHeader();
    this.Body = new BObjectBody();
    this.summary = new Array<BObjectSummary>();
  }
}

export class BObjectSummary {
  public CodeIdentUnique: string;
  public ColumnName: string;
  public IndexGroupsList: number;
  public IndexDataList: number;
  public CountMainElementList: number;
}

export class ParameterBoModel extends QueovalBase {
  public QueryString: string;
  public P1: string;    // TO DELETE
  public P2: string;    // TO DELETE
  public P3: string;    // TO DELETE
  public CodeBo: string;    // TO DELETE
  public IdDonnee: string;    // TO DELETE
  public FILE: string;    // TO DELETE
  public listItem: ListOption[];
  public multiclient: boolean;
}

export class ListOption {
  public text: string;
  public value: string;
}

export class BObjectHeader {
  public Title: string;
  public ButtonsList: HtmlButton[];
  public SavedModels: Array<QueovalDik>;
}

export class BObjectBody {
  //public GroupsList: PropertyGroup[];
  public SelectedGroupsList: PropertyGroup[];
  public SelectedGroup: PropertyGroup;
  constructor() {
    //this.GroupsList = new Array<PropertyGroup>();
    this.SelectedGroupsList = new Array<PropertyGroup>();
    this.SelectedGroup = new PropertyGroup;
  }
}

export class PropertyGroup {
  public ID: string;
  public Legend: string;
  public Unselectable: string;

  public template: string;
  public tplX: string;
  public tplY: string;
  public showTpl: boolean;

  //public cols: number;
  //public rows: number;
  //public x: number;
  //public y: number;
  public DataList: PropertyData[];
  constructor() {
    this.DataList = new Array<PropertyData>();
  }
}

export class PropertyData {
  public Type: string; 
  public Mode: string;
  public QueovalCode: string;
  public MainLabel: HtmlBase;
  public HistoryElement: HtmlBase;
  public MainElementList: HtmlBase[];
  public ElementsGrouped: boolean;
  public Disabled: boolean;
  public FilterBo: Array<QueovalDik>;
  public CodeValue: string;
  public CodeIdentUnique: string;

  constructor() {
    this.MainLabel = new HtmlBase('', '');
    this.HistoryElement = new HtmlBase('', '');
    this.MainElementList = new Array<HtmlBase>();
  }
}

export class DynamicGroup {
  public Date: string;
  public Input: HtmlBase;
}

export class UploadModel extends QueovalBase {
  public file: FormData;
  public InfoBo: BObjectModel;
}


//#region admin bo

export class BoProp {
  /// <summary>
  /// Retourne le nom de la propriete.
  /// </summary>
  public PropName: string;
  /// <summary>
  /// Retourne l'ident de la propriete.
  /// </summary>
  public PropId: string;
  public PropCode: string;
  /// <summary>
  /// Retourne le type de la propriete.
  /// </summary>
  public PropType: string;

  /// <summary>
  /// Retourne le nom de la colonne.
  /// </summary>
  public PropCol: string;
  /// <summary>
  /// Retourne le type de la colonne.
  /// </summary>
  public PropColType: string;
}

export class BoGroupProp {
  /// <summary>
  /// Retourne le nom de la propriete.
  /// </summary>
  public PropList: Array<BoProp>;
  /// <summary>
  /// Retourne le nom du groupe de la propriete.
  /// </summary>
  public PropGroupName: string;
  public PropGroupTemplate: string;
  public PropGroupTemplateX: string;
  public PropGroupTemplateY: string;

  constructor() {
    this.PropGroupTemplate = '';
  }
}

export class BoModel extends QueovalBase {
  // GET
  /// <summary>
  /// Retourne le nom du Bo selectionné.
  /// </summary>
  public StrBo: string;
  /// <summary>
  /// Retourne la liste des prorietes sur la table selectionné
  /// </summary>
  public DtProp: Array<any>;


  public ListProp: Array<BoGroupProp>;
  /// <summary>
  /// Retourne le chemin du serveur.
  /// </summary>
  public path: string;
  /// <summary>
  /// Retourne le nom de la table selectionné.
  /// </summary>
  public TableName: string;
  /// <summary>
  /// Retourne l'id de la table selectionné.
  /// </summary>
  public TableIdent: string;
  /// <summary>
  /// Retourne la liste des prorietes sur la table selectionné mais pas utilisé
  /// </summary>
  public dtListColumnNotUsed: Array<any>;
  public ListColumnNotUsed: Array<BoProp>;
  /// <summary>
  /// Retourne la liste des BO.
  /// </summary>
  public ListBo: Array<any>;
  /// <summary>
  /// Retourne la liste des type des colonnes de la base idbopBOV='TYPECOL'.
  /// </summary>
  public ListTypeCol: Array<any>;

  // POST
  /// <summary>
  /// Retourne l'etat du positionnement final proriete .
  /// </summary>
  public ListPropFinal: Array<string>;
  /// <summary>
  /// Retourne l'etat du positionnement initial proriete .
  /// </summary>
  public ListPropInitial: Array<string>;
  /// <summary>
  /// Retourne le nom de la colonne a crée.
  /// </summary>
  public ColumnName: string;
  /// <summary>
  /// Retourne les info de la colonne a crée.
  /// </summary>
  public ColumnInfo: string;
  /// <summary>
  /// Retourne le type de la colonne a crée.
  /// </summary>
  public ColumnType: string;
  /// <summary>
  /// Retourne le suffixe du nom de la colonne de la table selectionné.
  /// </summary>
  public Suffixe: string;
  /// <summary>
  /// Retourne true si l'utilisateur est 1389
  /// </summary>
  public IsSuperUser: boolean;
}

export class PropertyDetailsModel extends QueovalBase {
  public IdentBO: string;
  public IdentProp: string;
  public ComboField: string;
  public ComboDefault: ComboDefaultValue;
  public GroupData: Array<TableDefaultValue>;
  public Properties: Array<ComboBox>;
  constructor() {
    super();
    this.IdentBO = '0';
    this.IdentProp = '0';
    this.ComboField = '';
    this.ComboDefault = new ComboDefaultValue();
  }
}
export class ComboDefaultValue {
  public GroupData: GroupValueData;
  public NewGroupValue: TableDefaultValue;
  public ValuesToAdd: Array<number>;
  public ValuesToRemove: Array<number>;
  public LoadedValues: Array<TableDefaultValue>;
  public UnloadedValues: Array<TableDefaultValue>;
  constructor() {
    this.ValuesToAdd = new Array<number>();
    this.ValuesToRemove = new Array<number>();
    this.LoadedValues = new Array<TableDefaultValue>();
    this.UnloadedValues = new Array<TableDefaultValue>();
  }
}
export class TableDefaultValue {
  public Ident: number;
  public IdbopBOV: string;
  public VastrBOV: string;
  public VaintBOV: string;
  public Info_BOV: string;
  public IsSelected: boolean;
  public OnEdit: boolean;
  public AddToPropertyIdent: string;
}
export class GroupValueData {
  public Ident: number;
  public IdbopBOV: string;
  public VastrBOV: string;  
  public Info_BOV: string;
}
//#endregion

export class TemplateModel extends QueovalBase {
  public IdDonneePere: string;
  public IdDonneeFils: string;
  public IdRelation: string;
  public IdentBO: string;

  public QueryReturn: Dictionary<any>;

  constructor(pIdDonneePere: string, pIdDonneeFils: string, pIdRelation: string, pIdentBO: string) {
    super();
    this.IdDonneePere = pIdDonneePere;
    this.IdDonneeFils = pIdDonneeFils;
    this.IdRelation = pIdRelation;
    this.IdentBO = pIdentBO;

  }
}

export class listTemplate {
  public templateName: string;
  public templateToolTips: string;
  public templateTable: Array<string>;
  public templateComponent: string;

  constructor(ptemplateName: string, ptemplateToolTips: string, ptemplateTable: Array<string>, ptemplateComponent: string) {
    this.templateName = ptemplateName;
    this.templateToolTips = ptemplateToolTips;
    this.templateTable = ptemplateTable;
    this.templateComponent = ptemplateComponent;
  }
}


export enum ModeBo {
  Edit,
  Find
}

